import {
  AudienceOptionItem,
  AudienceOptions,
  AudienceType,
} from "../types/audience-compare";

import { envConfig } from "../config";
import geoSegmentsBaseline from "./geo-segments-baseline.json";

/**
 * Provides "hard coded" data specific for the Baseline dropdown.
 *
 * We do store IDs for "US Adults", "US Gen Pop", "Hispanics", and "Non-Hispanics"
 * in config as they are different across environments.
 */
export default [
  {
    value: envConfig.baselineUsGenPopId,
    label: "US Gen Pop",
    type: "segment",
    weighting: "us_census",
  },
  {
    value: envConfig.baselineUsAdultsId,
    label: "US Adults",
    type: "segment",
    weighting: "us_adults",
  },
  {
    value: envConfig.baselineUsHispanicId,
    label: "Hispanics",
    type: "segment",
    weighting: "us_online_hispanic_adults",
  },
  {
    value: envConfig.baselineUsNonHispanicId,
    label: "Non-Hispanics",
    type: "segment",
    weighting: "us_non_hispanic_adults",
  },
  ...geoSegmentsBaseline.sections.map((geo) => ({
    group: geo.label,
    items: geo.segments.map(
      (segment): AudienceOptionItem => ({
        value: segment.id,
        label: segment.name,
        type: "segment" satisfies AudienceType,
        weighting: segment.weighting,
      }),
    ),
  })),
] as AudienceOptions;
